
import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { QRCodeModule } from 'angularx-qrcode';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';

@Component({
    selector: 'qr-modal',
    templateUrl: './qr-modal.component.html',
    standalone: true,
    imports: [AfTranslateDirective, QRCodeModule]
})
export class QrModalComponent {
  constructor(private dialogRef: DynamicDialogRef<QrModalComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  url: string = this.dialogConfig.data.url;
  colorQR: string = document.documentElement.style.getPropertyValue('--Main-1000');

  downloadQR(){
    let svg: any = document.querySelector('.qr-modal__qr-code-container');
    let data: string = new XMLSerializer().serializeToString(svg);
    let svgBlob: Blob = new Blob([data], {type: 'image/svg+xml;charset=utf-8'});
    let url: string = URL.createObjectURL(svgBlob);
    this.triggerDownload(url);
  }

  triggerDownload (imgURI:any) {
    let a: HTMLAnchorElement = document.createElement('a');
    a.setAttribute('download', 'image.svg');
    a.setAttribute('href', imgURI);
    a.setAttribute('target', '_blank');
    a.click();
    this.handleAccept();
  }

  handleAccept() {
    this.dialogRef.close({result: 'ok'});
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }
}
